import type { NextRouter } from 'next/router';
import { type Dispatch, useEffect } from 'react';

import { getLastSearchFlight } from 'shared/search/common/lastSearch';
import actions from '../../../flight/flightActions';

export const useFlightInitialState = (
    dispatch: Dispatch<ReturnType<(typeof actions)[keyof typeof actions]>>,
    prefill: Record<string, string | number | boolean> | undefined,
    query: NextRouter['query'],
) => {
    useEffect(() => {
        let changedFields: Record<string, string | string[] | undefined | number | boolean | null>;

        // Should only override last search parameters with query params if override=true is in the query
        if (query.override) {
            // biome-ignore lint/correctness/noUnusedVariables: override is unused on purpose
            const { override, ...rest } = query;
            changedFields = rest;
        } else {
            changedFields = { ...getLastSearchFlight(), ...prefill };
        }

        dispatch(actions.allFieldsChanged(changedFields));
    }, []);
};
